import settings from '../settings';

/* eslint no-console: 0 */

/**
 * @public
 * Prints a warning message and notifies to Raygun.
 *
 * @param  {any} error: the warning message or error object
 * @param  {any} customData: the customData object
 * @return {void}
 */
export default function warn(error, customData = {}) {
  if (!settings.isProd) {
    if (typeof error === 'string') {
      console.warn(`%c${error}`);
    } else {
      console.warn(`%c${error.message}`);
    }
  }

  if (window.rg4js && typeof rg4js === 'function') {
    if (typeof error === 'string') {
      rg4js('send', {
        error: new Error(error),
        customData: [
          customData,
        ],
      });
    } else {
      rg4js('send', {
        error,
        customData: [
          customData,
        ],
      });
    }
  }
}
